// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------modal---------------- */

.UploadModal_boxModal__dPi\\+s {
  animation: UploadModal_init__vaP5n 0.3s;
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 90%;
  border-radius: 10px;
  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);
  font-size: 16px;
}

.UploadModal_selectContainer__7uAfn {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  margin-top: 2rem !important;
}

.UploadModal_selectInput__26S6J {
  width: 50%;
  color: black;
}

.UploadModal_boxModal__dPi\\+s .UploadModal_exit__3Dq-s {
  width: 90%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 30px;
  margin-top: 20px;
}

.UploadModal_boxModal__dPi\\+s .UploadModal_exit__3Dq-s .UploadModal_exitIcon__NtT0z {
  transition: 0.3s;
}

.UploadModal_boxModal__dPi\\+s .UploadModal_exit__3Dq-s .UploadModal_exitIcon__NtT0z:hover {
  transition: 0.2s;
  scale: 1.3;
  cursor: pointer;
  filter: brightness(1.6);
}

.UploadModal_boxModal__dPi\\+s .UploadModal_titleModal__w7q1H {
  width: 95%;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: flex-start;
  margin-top: 15px;
}

.UploadModal_boxModal__dPi\\+s .UploadModal_titleModal__w7q1H p {
  font-size: 1.2rem;
  margin: 0;
}

.UploadModal_boxModal__dPi\\+s .UploadModal_titleModal__w7q1H span {
  font-size: 1rem;
  color: #5a5a5a;
  margin: 5px 0 0;
}

.UploadModal_boxModal__dPi\\+s .UploadModal_filters__QEaZ2 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
}

.UploadModal_boxModal__dPi\\+s .UploadModal_filters__QEaZ2 .UploadModal_uploadContainer__CmlxA {
  transition: 0.3s;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 180px;
  margin: 30px;
  margin-bottom: 0px;
  border: 3px dashed darkgrey;
  border-radius: 10px;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.UploadModal_boxModal__dPi\\+s .UploadModal_filters__QEaZ2 .UploadModal_uploadContainer__CmlxA:hover {
  scale: 1.02;
  border: 3px dashed rgba(37, 37, 37, 0.682);
}

.UploadModal_boxModal__dPi\\+s .UploadModal_filters__QEaZ2 .UploadModal_uploadContainer__CmlxA .UploadModal_uploadIcon__Kg95y {
  transition: 0.3s;
  opacity: 1;
  transform: translateY(20px);
  filter: drop-shadow(0px 10px 15px -3px rgba(0, 0, 0, 0.1));
}

.UploadModal_boxModal__dPi\\+s .UploadModal_filters__QEaZ2 .UploadModal_uploadContainer__CmlxA:hover .UploadModal_uploadIcon__Kg95y {
  scale: 1.2;
  rotate: 5deg;
  transition: 0.3s;
  transform: translateY(0px);
}

.UploadModal_boxModal__dPi\\+s .UploadModal_filters__QEaZ2 .UploadModal_uploadContainer__CmlxA .UploadModal_textUpload__FHsub {
  transition: 0.3s;
  opacity: 0;
  transform: translateY(20px);
  margin-top: 15px;
  font-size: 1.2rem;
  font-weight: 400;
}

.UploadModal_boxModal__dPi\\+s .UploadModal_filters__QEaZ2 .UploadModal_uploadContainer__CmlxA:hover .UploadModal_textUpload__FHsub {
  transition: 0.3s;
  opacity: 1;
  transform: translateY(0px);
}

.UploadModal_boxModal__dPi\\+s .UploadModal_filters__QEaZ2 .UploadModal_button__LKoX4 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
}

.UploadModal_boxModal__dPi\\+s .UploadModal_filters__QEaZ2 .UploadModal_uploadContainer__CmlxA .UploadModal_itemsFile__CvwUe {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.UploadModal_boxModal__dPi\\+s .UploadModal_filters__QEaZ2 .UploadModal_uploadContainer__CmlxA .UploadModal_itemsFile__CvwUe p {
  margin: 0;
  margin-top: 5px;
  transition: 0.3s;
  opacity: 1;
  font-size: 1.1rem;
  font-weight: 400;
}

@media screen and (max-width: 900px) {
  .UploadModal_boxModal__dPi\\+s {
    background-color: rgba(238, 238, 238, 0.95);
    transition: 0.3s;
    min-height: 100%;
    border-radius: 0;
    box-shadow: none;
  }
}

@keyframes UploadModal_init__vaP5n {
  0% {
    top: 55%;
    opacity: 0;
  }

  100% {
    top: 50%;
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/ProcessFiles/ArchivosSalvta/UploadModal/UploadModal.module.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,uCAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B,0DAA0D;AAC5D;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,2CAA2C;IAC3C,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF","sourcesContent":["/* -----------------modal---------------- */\n\n.boxModal {\n  animation: init 0.3s;\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-height: 90%;\n  border-radius: 10px;\n  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);\n  font-size: 16px;\n}\n\n.selectContainer {\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  margin-top: 2rem !important;\n}\n\n.selectInput {\n  width: 50%;\n  color: black;\n}\n\n.boxModal .exit {\n  width: 90%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 30px;\n  margin-top: 20px;\n}\n\n.boxModal .exit .exitIcon {\n  transition: 0.3s;\n}\n\n.boxModal .exit .exitIcon:hover {\n  transition: 0.2s;\n  scale: 1.3;\n  cursor: pointer;\n  filter: brightness(1.6);\n}\n\n.boxModal .titleModal {\n  width: 95%;\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  align-items: flex-start;\n  margin-top: 15px;\n}\n\n.boxModal .titleModal p {\n  font-size: 1.2rem;\n  margin: 0;\n}\n\n.boxModal .titleModal span {\n  font-size: 1rem;\n  color: #5a5a5a;\n  margin: 5px 0 0;\n}\n\n.boxModal .filters {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 40px;\n}\n\n.boxModal .filters .uploadContainer {\n  transition: 0.3s;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 180px;\n  margin: 30px;\n  margin-bottom: 0px;\n  border: 3px dashed darkgrey;\n  border-radius: 10px;\n  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n.boxModal .filters .uploadContainer:hover {\n  scale: 1.02;\n  border: 3px dashed rgba(37, 37, 37, 0.682);\n}\n\n.boxModal .filters .uploadContainer .uploadIcon {\n  transition: 0.3s;\n  opacity: 1;\n  transform: translateY(20px);\n  filter: drop-shadow(0px 10px 15px -3px rgba(0, 0, 0, 0.1));\n}\n\n.boxModal .filters .uploadContainer:hover .uploadIcon {\n  scale: 1.2;\n  rotate: 5deg;\n  transition: 0.3s;\n  transform: translateY(0px);\n}\n\n.boxModal .filters .uploadContainer .textUpload {\n  transition: 0.3s;\n  opacity: 0;\n  transform: translateY(20px);\n  margin-top: 15px;\n  font-size: 1.2rem;\n  font-weight: 400;\n}\n\n.boxModal .filters .uploadContainer:hover .textUpload {\n  transition: 0.3s;\n  opacity: 1;\n  transform: translateY(0px);\n}\n\n.boxModal .filters .button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100px;\n}\n\n.boxModal .filters .uploadContainer .itemsFile {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.boxModal .filters .uploadContainer .itemsFile p {\n  margin: 0;\n  margin-top: 5px;\n  transition: 0.3s;\n  opacity: 1;\n  font-size: 1.1rem;\n  font-weight: 400;\n}\n\n@media screen and (max-width: 900px) {\n  .boxModal {\n    background-color: rgba(238, 238, 238, 0.95);\n    transition: 0.3s;\n    min-height: 100%;\n    border-radius: 0;\n    box-shadow: none;\n  }\n}\n\n@keyframes init {\n  0% {\n    top: 55%;\n    opacity: 0;\n  }\n\n  100% {\n    top: 50%;\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxModal": `UploadModal_boxModal__dPi+s`,
	"init": `UploadModal_init__vaP5n`,
	"selectContainer": `UploadModal_selectContainer__7uAfn`,
	"selectInput": `UploadModal_selectInput__26S6J`,
	"exit": `UploadModal_exit__3Dq-s`,
	"exitIcon": `UploadModal_exitIcon__NtT0z`,
	"titleModal": `UploadModal_titleModal__w7q1H`,
	"filters": `UploadModal_filters__QEaZ2`,
	"uploadContainer": `UploadModal_uploadContainer__CmlxA`,
	"uploadIcon": `UploadModal_uploadIcon__Kg95y`,
	"textUpload": `UploadModal_textUpload__FHsub`,
	"button": `UploadModal_button__LKoX4`,
	"itemsFile": `UploadModal_itemsFile__CvwUe`
};
export default ___CSS_LOADER_EXPORT___;
